module.exports = ""


//////////////////
// WEBPACK FOOTER
// /mnt/volume_sfo2_01/www/html/xpress-dev/src/app/auth/logout/logout.component.html
// module id = ../../../../../src/app/auth/logout/logout.component.html
// module chunks = main